import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Configuration } from 'src/app/models/configurators-2d/applications/closet-doors-custom/configuration/configuration';
import {
  CD_CUSTOM_CLOSET_CONFIGURATION,
  CD_CUSTOM_ENVIRONMENT,
  CD_CUSTOM_FINISHES,
  CD_CUSTOM_SUPPLIERS,
  CD_CUSTOM_ACCESSORIES,
  CD_CUSTOM_SUMMARY,
} from 'src/app/providers/closet-doors-custom.provider';
import { ClosetDoorsCustomService } from 'src/app/services/configurators-2d/applications/closet-doors-custom.service';
import { BaseConfigurator } from '../../configurator/base-configurator';
import { ConfiguratorStructure } from '../../configurator/configurator-structure';

@Component({
  selector: 'ng-closet-doors-custom-configuration',
  templateUrl: './closet-doors-custom.component.html',
})
export class ClosetDoorsCustomComponent
  extends BaseConfigurator<Configuration, ClosetDoorsCustomService>
  implements OnInit, OnDestroy
{
  @Input() step: number = 1;

  @Output() setGlobalLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() getFinishesStep: EventEmitter<any> = new EventEmitter<boolean>();

  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    closetDoorsCustomService: ClosetDoorsCustomService,
    injector: Injector
  ) {
    super(closetDoorsCustomService, injector);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadExistingConfigurationIfNeeded(this.route).then(() => {
      this.setGlobalLoading.emit(false);
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.service.reset();
  }

  override initConfigurator(): ConfiguratorStructure {
    return new ConfiguratorStructure([
      {
        index: 1,
        title: 'closet-doors-custom.steps.environment',
        injectionToken: CD_CUSTOM_ENVIRONMENT,
        gtmTitle: 'Portes de Placard sur Mesure | Votre Environnement',
        gtmPageName: 'votre-environnement',
      },
      {
        index: 2,
        title: 'closet-doors-custom.steps.closet-configuration',
        injectionToken: CD_CUSTOM_CLOSET_CONFIGURATION,
        gtmTitle: 'Portes de Placard sur Mesure | Placard',
        gtmPageName: 'placard',
      },
      {
        index: 3,
        title: 'closet-doors-custom.steps.suppliers',
        injectionToken: CD_CUSTOM_SUPPLIERS,
        gtmTitle: ' Portes de Placard sur Mesure | Fournisseur et Gamme',
        gtmPageName: 'fournisseur-et-gamme',
      },
      {
        index: 4,
        title: 'closet-doors-custom.steps.finishes',
        injectionToken: CD_CUSTOM_FINISHES,
        gtmTitle: 'Portes de Placard sur Mesure | Finition',
        gtmPageName: 'finition',
      },
      {
        index: 5,
        title: 'closet-doors-custom.steps.accessories',
        injectionToken: CD_CUSTOM_ACCESSORIES,
        gtmTitle: 'Portes de Placard sur Mesure | Accessoires',
        gtmPageName: 'accessoires',
      },
      {
        index: 6,
        title: 'closet-doors-custom.steps.summary',
        injectionToken: CD_CUSTOM_SUMMARY,
        gtmTitle: 'Portes de Placard sur Mesure | Prix et Résumé',
        gtmPageName: 'prix-et-resume',
      },
    ]);
  }
}
